export default function Footer() {
  return (
    <footer className="py-16 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <p className="font-display text-3xl text-white">CHASE @ CURRY</p>
          <p className="font-sub text-sm text-zinc-500 mt-2">
            Curry College · Milton, MA · Class of 2030 · Colonels Football
          </p>
        </div>
        <div className="font-sub text-sm text-zinc-500">
          <p>Made with 💜 by family, for the only purple turf in college football.</p>
          <p className="mt-1">Cash App blessings: <span className="text-[#00d632] font-semibold">$Vanilla3808</span></p>
          <p className="mt-1">Gift cards & email: <a href="mailto:clang8858@gmail.com" data-testid="footer-email-link" className="text-purple-400 hover:text-purple-300 font-semibold transition-colors duration-200">clang8858@gmail.com</a></p>
        </div>
      </div>
    </footer>
  );
}
